import React, { useMemo } from "react";
import { Controller } from "react-hook-form";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText
} from "@mui/material";

// --- helpers ---
const pad2 = (n) => String(n).padStart(2, "0");
const strToMinutes = (hhmm) => {
  if (!hhmm) return null;
  const [h, m] = hhmm.split(":").map(Number);
  if (!Number.isFinite(h) || !Number.isFinite(m)) return null;
  return h * 60 + m;
};
const minutesToStr = (mins) => {
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return `${pad2(h)}:${pad2(m)}`;
};

function buildOptions(start = "06:30", end = "18:00", step = 15) {
  const s = strToMinutes(start);
  const e = strToMinutes(end);
  if (s == null || e == null || step <= 0) return [];
  const out = [];
  for (let t = s; t <= e; t += step) {
    const v = minutesToStr(t);
    const hour = Math.floor(t / 60);
    const min = t % 60;
    const ampm = hour < 12 ? "AM" : "PM";
    const h12 = hour % 12 === 0 ? 12 : hour % 12;
    const nice = `${h12}:${pad2(min)} ${ampm}`;
    out.push({ value: v, label: nice });
  }
  return out;
}

const FormTimeField = ({
  name,
  control,
  label = "Hora",
  required = false,
  start = "06:30",
  end = "18:00",
  step = 15,
  defaultValue = "",
  disabled = false,
  error,         
  fullWidth = true,
  onChange
}) => {
  const options = useMemo(() => buildOptions(start, end, step), [start, end, step]);

  return (
    <FormControl size="small" fullWidth={fullWidth} error={Boolean(error)}>
      <InputLabel id={`${name}-label`} shrink required={required}>
        {label}
      </InputLabel>

      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <Select
            labelId={`${name}-label`}
            id={name}
            {...field}
            value={field.value ?? ""}
            onChange={(e) => {
              field.onChange(e.target.value);
              onChange?.(e.target.value);
            }}
            disabled={disabled}
            displayEmpty
            inputProps={{ inputMode: "none" }}
          >
 

            {options.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        )}
      />

      {error ? (
        <FormHelperText>{error.message || "Campo inválido"}</FormHelperText>
      ) : null}
    </FormControl>
  );
};

export default FormTimeField;
